// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'
import { throttle } from 'lodash'

export default class MainHamburgerComponent extends Component {

  constructor(element) {
    super(element);

    this.isOpen = false
    this.body = document.body

    this.ref = {
      button: null
    }
  }


  mount() {
 
    this.ref.button.addEventListener('click', this.toggleMenu.bind(this));
    window.addEventListener('scroll', throttle(this.scrollReset.bind(this),200));
  }

  toggleMenu(e) { 
    e.preventDefault();
    this.body.classList.toggle('main-menu-open');
    this.isOpen = this.body.classList.contains('main-menu-open');

  }

  scrollReset(e) {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);



//     const body = document.body;
// const triggerMenu = document.querySelector(".page-header .trigger-menu");
// const nav = document.querySelector(".page-header nav");
// const menu = document.querySelector(".page-header .menu");
// const scrollUp = "scroll-up";
// const scrollDown = "scroll-down";
// let lastScroll = 0;

// triggerMenu.addEventListener("click", () => {
//   body.classList.toggle("menu-open");
// });

// window.addEventListener("scroll", () => {
//   const currentScroll = window.pageYOffset;
//   if (currentScroll <= 0) {
//     body.classList.remove(scrollUp);
//     return;
//   }
  
//   if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
//     // down
//     body.classList.remove(scrollUp);
//     body.classList.add(scrollDown);
//   } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
//     // up
//     body.classList.remove(scrollDown);
//     body.classList.add(scrollUp);
//   }
//   lastScroll = currentScroll;
// });

    
 
  }
}
